const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://nadeedapi.urapp4u.com/api';

// The API returns stored files as server-relative paths ("/uploads/x.png").
// Strip the trailing /api segment to get the host that actually serves them.
export const getFileUrl = (path) => {
  if (!path) return null;
  return `${API_BASE_URL.replace('/api', '')}${path}`;
};

export default getFileUrl;
